import React from 'react';
import { Flex } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { MdLaunch } from 'react-icons/md';
import { IoMdCalendar } from 'react-icons/io';
import {
  VehicleInformationContainer,
  VehicleTitle,
  Separator,
  VehicleInfoLabel,
  VehicleInfoValue,
} from '../../styles';
import { VEHICLE_DETAILS, vehicleData } from '../../constants';

interface IVehicleInformationProps {
  isMobile: boolean;
}

export const VehicleInformation = ({ isMobile }: IVehicleInformationProps) => {
  return (
    <VehicleInformationContainer isMobile={isMobile} className='font-roboto'>
      <Flex gap='7px'>
        <Flex gap='7px'>
          <VehicleTitle>
            {vehicleData.year} {vehicleData.make} {vehicleData.model}
          </VehicleTitle>
          <VehicleTitle>Please Call For Price</VehicleTitle>
        </Flex>
        <Separator />
        <Flex gap='4px'>
          {VEHICLE_DETAILS.map(({ label, value }) => (
            <Flex key={label} flexDirection='row' gap='14px'>
              <VehicleInfoLabel>{label}:</VehicleInfoLabel>
              <VehicleInfoValue>{value}</VehicleInfoValue>
            </Flex>
          ))}
        </Flex>
        <Flex gap='4px'>
          <Button
            text='Vehicle Detail Page'
            variant='secondary'
            size='small'
            style={{
              minHeight: 16,
              maxHeight: 16,
              width: '100%',
              fontSize: '6.5px',
              padding: '2px 6px 2px 3px',
              borderRadius: '3px',
            }}
            icon={<MdLaunch width={10} height={10} />}
          />
          <Button
            text='Schedule Test Drive'
            size='small'
            style={{
              minHeight: 16,
              maxHeight: 16,
              width: '100%',
              fontSize: '6.5px',
              padding: '2px 6px 2px 3px',
              borderRadius: '3px',
            }}
            icon={<IoMdCalendar width={10} height={10} />}
          />
        </Flex>
      </Flex>
    </VehicleInformationContainer>
  );
};
